module.exports = __webpack_public_path__ + "static/media/8OLA31.f0c9f109.jpg";